import React, { useState } from "react";
import axios from "axios";
import "./Search.css";
import { TailSpin } from "react-loader-spinner";
import WeatherInfo from "./WeatherInfo";
import Forecast from "./Forecast";

export default function Search(props) {
  //let city = props;
  //alert(props.city);
  let apiKey = "69967927e28d8590b78f96c348d2023b";

  let [search, setSearch] = useState(""); //variable for checkig status of input data
  let [weather, setWeather] = useState({ ready: false }); // status for drawing WeatherInfo (using in Object)

  //alert(`hello ${search}`);
  function showWeather(response) {
    let weather = {
      //building new Object - API response
      ready: true, // status for drawing WeatherInfo
      city: response.data.name,
      country: response.data.sys.country,
      date: response.data.dt * 1000,
      temperature: Math.round(response.data.main.temp),
      description: response.data.weather[0].description,
      humidity: response.data.main.humidity,
      wind: response.data.wind.speed,
      pressure: response.data.main.pressure,
      icon: response.data.weather[0].icon,
      coordinates: response.data.coord,
    };
    //console.log(weather); //look what is in response
    setWeather(weather); //set weather
  }

  function updateWeather(event) {
    //if smth changed
    event.preventDefault();
    setSearch(event.target.value);
  }

  function handleSubmit(event) {
    //if button Search pressed
    event.preventDefault();
    searchCity(search); //call function to make API call
  }

  function searchCity(city) {
    //function for calling API
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(showWeather); //call function for seathing weather
  }

  if (weather.ready) {
    return (
      <div className="Search">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-6 mb-3">
              <input
                type="search"
                placeholder="Enter your city"
                autoFocus="on"
                className="search-input"
                onChange={updateWeather}
              />
            </div>
            <div className="col-6 mb-3">
              <input type="submit" className="btn search-btn" value="Search" />

             
            </div>
          </div>
        </form>
        <WeatherInfo data={weather} />
        <Forecast coordinates={weather.coordinates} />
      </div>
    );
  } else {
    searchCity(props.defaultCity);
    return <TailSpin height="50" width="50" radius="9" color="#2c5d63" />;
  }
}
